<template>
  <div>
    <div v-if="route === 'jewellery-catalogue'">
      <div v-for="(jewellery, index) in jewelries" :key="jewellery.SKU">
        <div
          class="page-grid"
          v-if="
            (loop === 0 && jewellery.SKU === featuredJewellery.first) ||
            (loop === 1 && jewellery.SKU === featuredJewellery.second) ||
            (loop === 2 && jewellery.SKU === featuredJewellery.third) ||
            (loop === 3 && jewellery.SKU === featuredJewellery.fourth)
          "
        >
          <article v-if="index" class="grid-container image-right columns-two border no-gap">
            <section class="section1">
              <span v-for="(img, idx) in featuredJewelriesImgs" :key="img[0].SKU">
                <div
                  v-if="jewellery.SKU === img[0].SKU"
                  class="bg-image"
                  :style="{ backgroundImage: 'url(/jewelries/gallery/NJ-' + jewellery.SKU + '/gallery-small-image/' + img[0].name + ')' }"
                ></div>
              </span>
            </section>

            <section class="section2 transparent">
              <div>
                <h2>{{ jewellery.Name }}</h2>
                <div>
                    <template v-if="jewellery.StatusName === 'Sold'">
                      <span>Sold</span>
                    </template>
                    
                    <template v-else>
                      <!-- <span v-if="jewellery.StatusName === 'Sold'">Sold</span> -->
                      <span class="status">{{ jewellery.StatusName }}
                          <span>&nbsp;|&nbsp;&nbsp;</span>
                        </span>

                      <span
                        class="price"
                        v-if="Number(jewellery.Price) > Number(sitePOA || Infinity)"
                      >
                        POA
                      </span>
                      <span class="price" v-else>
                        <span class="currency" v-if="jewellery.Currency === '£'">£</span>
                        <span class="currency" v-if="jewellery.Currency === 'CHF'">CHF</span>
                        <span class="currency" v-if="jewellery.Currency === 'USD'">$</span>
                        <span class="currency" v-if="jewellery.Currency === 'AED'">AED</span>
                        <span v-if="!jewellery.Currency" class="currency">$</span>
                        {{ $formatNumber(jewellery.Price) }}
                      </span>
                      
                      <div class="description fj" v-html="jewellery.Description"></div>
                    </template>
                </div>

                <router-link :to="{ name: 'jewellerycard', params: { jewellerySKU: jewellery.SKU } }">
                  <button v-if="jewellery.Name.length" class="right clean-link">
                    View more
                    <img class="center" src="/images/icons/ArrowRight.svg" />
                  </button>
                </router-link>
              </div>
            </section>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturedJewellery',
  props: {
    route: String,
    loop: Number,
    sitePOA: Number,
    // siteSettings: {
    //   type: Object,
    //   required: true
    // }
  },
  data() {
    return {
      jewelries: [],
      featuredJewellery: [],
      featuredJewelriesImgs: ''
    };
  },
  mounted() {
    this.getJewelries();
    this.getFeaturedJewelries();
    this.getFeaturedJewelriesImgs();
  },
  methods: {
    getJewelries(address) {
      this.$axios.get(address || '/api/jewelries').then((response) => {
        this.jewelries = response.data.data;
      });
    },
    getFeaturedJewelries(address) {
      this.$axios.get(address || '/api/featuredjewelries').then((response) => {
        this.featuredJewellery = response.data[0][0];
      });
    },
    getFeaturedJewelriesImgs(address) {
      this.$axios.get(address || '/api/featuredjewelriesimgs').then((response) => {
        this.featuredJewelriesImgs = response.data[0];
      });
    }
  }
};
</script>
